import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import CallIcon from "@mui/icons-material/Call";
import JourneyVideo from "./video";
import { Box, Grid, Paper, Stack, Typography } from "@mui/material";
import { Images } from "../../constants/images";
import { useStyles } from "./indexStyles";
import { withStyles } from "@mui/styles";
import {
  AVIVA_PARTNER_CODE,
  DBGB_PARTNER_CODE,
  DEFAULT_PARTNER_CODE,
  TERM_PARTNER_CODE,
  SLUG_OPEN,
} from "../../constants";
import { Utils } from "../../constants/utils";
import { keyframes } from "@emotion/react";
import { motion, AnimatePresence } from "framer-motion";
import { renderLogoProperty, renderSupportText } from "../../helpers/lead";
import { getStorageItem } from "../../helpers/utils";

// Animation: Pulse effect
const pulse = keyframes`
  0% { transform: scale(1); opacity: 0.8; }
  50% { transform: scale(1.2); opacity: 1; }
  100% { transform: scale(1); opacity: 0.8; }
`;

const bounce = keyframes`
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-6px);
  }
`;

function SubHeader({
  classes: {
    avivaLogo,
    bgColorDark,
    watchDemo,
    headerBox,
    headerBoxContainer,
    headerText,
    logo,
  },
}) {
  // Inside your component
  const location = useLocation();
  const [modal, setModal] = useState({ [SLUG_OPEN]: false });
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open]);

  const handleClickOutside = (event) => {
    if (containerRef.current && !containerRef.current.contains(event.target)) {
      setOpen(false);
    }
  };

  const handleCall = () =>
    (window.location.href = `tel:${renderSupportText("number")}`);

  const handleWatchDemo = () => toggleModal(SLUG_OPEN, true);

  const handleOnClose = (event, reason, modalKey) => {
    if (Utils.dialogOnCloseReasons.indexOf(reason) === -1) {
      handleClose(modalKey, false);
    }
  };

  const handleClose = () => toggleModal(SLUG_OPEN, false);

  const toggleModal = (keyname = SLUG_OPEN, flag = true) =>
    setModal({ [keyname]: flag });

  return (
    <Box className={headerBoxContainer}>
      <Box className={`${headerBox} ${bgColorDark}`}>
        <Box className={headerText}>
          <Grid container>
            <Grid item xs={12}>
              <Box
                display={"flex"}
                justifyContent={"center"}
                alignItems={"center"}
              >
                {getStorageItem("partnerCode") && (
                  <img
                    src={renderLogoProperty("name")}
                    className={
                      getStorageItem("partnerCode") === DEFAULT_PARTNER_CODE ||
                      getStorageItem("partnerCode") === DBGB_PARTNER_CODE
                        ? logo
                        : avivaLogo
                    }
                    alt="Aviva India"
                    style={{
                      width:
                        getStorageItem("partnerCode") === AVIVA_PARTNER_CODE ||
                        getStorageItem("partnerCode") === TERM_PARTNER_CODE
                          ? "auto"
                          : "100%", // Ensures image fits the box width
                      height: "revert-layer", // Maintains aspect ratio
                      maxWidth: "96%", // Prevents overflow
                    }}
                  />
                )}
              </Box>

              {/* Sliding Container */}
              <AnimatePresence>
                {open && (
                  <motion.div
                    ref={containerRef}
                    initial={{ x: "100%" }}
                    animate={{ x: 0 }}
                    exit={{ x: "100%" }}
                    transition={{ type: "tween", duration: 0.3 }}
                    style={{
                      position: "fixed",
                      top: "40%",
                      right: 0,
                      height: 106,
                      width: 200,
                      zIndex: 1100,
                    }}
                  >
                    <Paper
                      elevation={4}
                      sx={{
                        height: "100%",
                        padding: "6px 6px 20px 6px",
                        backgroundColor: "#ffd900",
                        borderTopLeftRadius: "8px",
                        borderBottomLeftRadius: "8px",
                        textAlign: "left",
                      }}
                    >
                      <Box mt={1}>
                        <Stack
                          direction="row"
                          alignItems="center"
                          spacing={1}
                          onClick={handleWatchDemo}
                        >
                          <PlayCircleOutlineIcon fontSize="small" />
                          <Typography variant="body1">Watch Demo</Typography>
                        </Stack>
                      </Box>
                      <Box mt={2}>
                        <Stack
                          direction="row"
                          alignItems="flex-start"
                          spacing={1}
                          onClick={handleCall}
                        >
                          <CallIcon fontSize="small" />
                          <Box flexDirection={"column"}>
                            <Typography variant="body1">
                              {renderSupportText("number")}
                            </Typography>
                            <Typography
                              variant="caption"
                              sx={{ fontStyle: "italic" }}
                            >
                              <small>
                                {`(${renderSupportText(
                                  "days"
                                )}, ${renderSupportText("timing")})`}
                              </small>
                            </Typography>
                          </Box>
                        </Stack>
                      </Box>
                    </Paper>
                  </motion.div>
                )}
              </AnimatePresence>

              {!open && location?.pathname === "/" && (
                <Box className={watchDemo}>
                  <Typography variant="subtitle1" onClick={() => setOpen(true)}>
                    SUPPORT
                  </Typography>
                </Box>
              )}
            </Grid>
          </Grid>
        </Box>
      </Box>

      {modal.open && <JourneyVideo onClose={handleOnClose} modal={modal} />}
    </Box>
  );
}

export default withStyles(useStyles, { withTheme: true })(SubHeader);
